'use client'

import { AuthContext } from '@/app/components/providers/AuthProvider'
import { logger } from '@/lib/logger'
import { Session } from '@/types/core-types'
import { useQuery } from '@tanstack/react-query'
import { useCallback, useContext, useEffect, useState } from 'react'
import { fetchSession } from '../actions/fetch-session'

export type SessionStatus = 'loading' | 'authenticated' | 'unauthenticated' | 'anonymous'

export const useSession = () => {
  const { session, status } = useContext(AuthContext)
  const [currentSession, setCurrentSession] = useState(session)
  //const { data, isLoading } = useQuery(['session'], fetchSession, {})

  useEffect(() => {
    setCurrentSession(session)
  }, [session])
  return { session: currentSession, isLoading: status === 'loading' }
}
export default useSession
